const animationItemProcessor = (config, classes:string[] = []) => {

  config.forEach(configItem => {
    const items: NodeListOf<HTMLElement> = document.querySelectorAll(configItem.selector)
    if (items.length) {
      Array.from(items).forEach((item:HTMLElement) => {
        if (configItem.wrapper) {
          item = item.closest(configItem.wrapper) || item;
        }

        Object.entries(configItem.dataset).map(([key, value]) => {
          item.dataset[key] = value as string
        })

        if (classes.length) {
          classes.forEach((className:string) => {
            item.classList.add(className)
          })
        }
      })
    }
  })
}

const animationIsRequired = (config) => {
  let isRequired:boolean = false
  config.forEach((item:Object) => {
    if (document.querySelectorAll(item['selector']).length) isRequired = true
  })
  return isRequired
}

export {
  animationItemProcessor,
  animationIsRequired
}
